import { render, staticRenderFns } from "./custom-table.vue?vue&type=template&id=cc67a4f6&"
import script from "./custom-table.vue?vue&type=script&lang=ts&"
export * from "./custom-table.vue?vue&type=script&lang=ts&"
import style0 from "./custom-table.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports